import classnames from 'classnames';
import React from 'react';
import { listItem, radioButton, selectedRadioButton } from './styles.mod.scss';

export default function FilterOptionListItem({ children, isActive, onClick }) {
  return (
    <li className={listItem} onClick={onClick}>
      <span
        className={classnames(radioButton, { [selectedRadioButton]: isActive })}
      />
      {children}
    </li>
  );
}
